import {getId, getType} from 'apis/model/base'
import {organizationPermissionCodes} from 'modules/permissions/contants'
import React, {useContext} from 'react'
import {compose, fromRenderProps, nest} from 'recompose'
import {createCheckPermissions,} from 'views/AppLocals/factory/createCheckPermissions'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import WorkspaceChannelList from '../Container/WorkspaceChannelList'
import WorkspaceEventList from '../Container/WorkspaceEventList'
import WorkspaceContext from '../WorkspaceContext'
import WorkspaceOrganizationAnnouncements from "../Insights/WorkspaceOrganizationAnnouncements";
import UnderDevelopment from "../../Shared/components/UnderDevelopment"
import WorkspaceModerationList from './containers/WorkspaceModerationList';
import useTranslate from "../../../modules/local/useTranslate";
import _ from "lodash";
import {useAnnouncementForm} from "../../AppLocals/Announcement/useAnnouncementForm";
import WorkspaceActivityCalendar from "../HomePage/WorkspaceActivityCalendar";
import MainContext from "../../MainPage/MainContext";
import renderLoading from "../../MainPage/functions/renderPagingLoading";

const ItemKeys = Object.freeze({
    ANNOUNCEMENTS:     'announcements',
    ARTICLES:          'articles',
    EVENTS:            'events',
    CHANNELS:          'channels',
    ACTIVITY_SCHEDULE: 'activity-schedule',
    MEDIA_LIBRARY:     'media-library',
    MODERATION:        'moderation',
})

const AnnouncementsTab = () => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext)
    const groups = _.get(organization, 'groups', [])

    const {modal, handleAction, refresh_token} = useAnnouncementForm({
        owner_type: 'organization',
        organization,
        groups,
        notifyListeners: {},
    })

    return (
        <div className="flex flex-col gap-6">
            <WorkspaceOrganizationAnnouncements refreshToken={refresh_token}/>
            {modal}
            <div className="h-16"/>
        </div>
    )
}

const routeEntities = [
    {
        key: ItemKeys.ANNOUNCEMENTS,
        component: AnnouncementsTab,
    },
    {
        key: ItemKeys.ARTICLES,
        component: UnderDevelopment,
    },
    {
        key: ItemKeys.CHANNELS,
        component: createCheckPermissions([
            organizationPermissionCodes.organizationManageChannel,
        ])(WorkspaceChannelList),
    },
    {
        key: ItemKeys.EVENTS,
        component: createCheckPermissions([
            organizationPermissionCodes.organizationManageEvent,
        ])(WorkspaceEventList),
    },
    {
        key: ItemKeys.ACTIVITY_SCHEDULE,
        component: WorkspaceActivityCalendar,
    },
    {
        key: ItemKeys.MEDIA_LIBRARY,
        component: UnderDevelopment,
    },
    {
        key: ItemKeys.MODERATION,
        component: WorkspaceModerationList,
    }
].map(({key, ...rest}) => ({
    key,
    path: key,
    ...rest,
}))

const WorkspaceActivities = ({owner_id, owner_type}) => {
    const {isLoading} = useContext(MainContext)

    const {activeKey, Component, onMenuSelect} = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    return (
        <div className="px-3 md:px-6">
            {!!isLoading ? renderLoading() : <Component/>}
        </div>
    )
}

export default nest(
    // withProps({lazy: true})(DelayRender),
    compose(
        fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
            owner_id: getId(organization),
            owner_type: getType(organization),
        }))
    )(WorkspaceActivities)
)
